module.exports = __webpack_public_path__ + "static/media/06.83fc0c8d.mp3";